import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['SM', 'S.M.', 'ESL Teacher — London, United Kingdom', '“I no longer spend my Sunday nights building lessons from scratch. I open the system, choose the lesson, and I walk in completely prepared. My students feel the difference — and so do I.”'], ['CV', 'C.V.', 'ESL Instructor — Toronto, Canada', '“The emergency lessons alone saved me three times in the first month. That bonus is worth the entire price on its own.”'], ['JR', 'J.R.', 'ESL Teacher — Sydney, Australia', '“The grammar guide changed how I explain structures completely. My explanations are clearer, my students understand faster, and I never blank in the middle of a class anymore.”']];
export function TestimonialsStrip() {
  return <section className="border-y border-line bg-charcoal px-4 py-12" data-id="element-223">
      <div className="mx-auto grid max-w-7xl gap-5 md:grid-cols-3" data-id="element-224">
        {testimonials.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.12
      }} className="rounded-2xl border border-gold-700/40 bg-black p-6" data-id="element-225">
            <div className="mb-4 flex gap-1 text-gold-300" data-id="element-226">
              {Array.from({
            length: 5
          }).map((_, starIndex) => <StarIcon key={starIndex} size={15} fill="currentColor" data-id="element-227" />)}
            </div>
            <p className="min-h-24 text-sm leading-6 text-stone-300 italic" data-id="element-228">
              {quote}
            </p>
            <div className="mt-6 flex items-center gap-3" data-id="element-229">
              <span className="grid h-10 w-10 place-items-center rounded-full border border-gold-500 bg-gold-700/15 text-sm font-bold text-gold-300" data-id="element-230">
                {initials}
              </span>
              <div data-id="element-231">
                <p className="text-sm font-bold text-white" data-id="element-232">{name}</p>
                <p className="text-xs text-gold-100" data-id="element-233">{role}</p>
              </div>
            </div>
          </motion.article>)}
      </div>
    </section>;
}